
function waitForElm(selector) {
  return new Promise(resolve => {if (document.querySelector(selector)) {return resolve(document.querySelector(selector));}const observer = new MutationObserver(mutations => {if (document.querySelector(selector)) {resolve(document.querySelector(selector));observer.disconnect();}});observer.observe(document.body, {childList: true,subtree: true});});
} 

function toggleCollectionDesc(e){
  let isActive = $(e).hasClass('active')

  if (isActive){
    $(e).text('Read More')
    $(e).removeClass('active')
    $('.description_rest').addClass('hide')
  }else {
    // Show rest of description
    $(e).text('Read Less')
    $(e).addClass('active')
    $('.description_rest.hide').removeClass('hide')
  }
  

}